'use client';

import type {Map as MapboxMap} from 'mapbox-gl';
import {twJoin} from 'tailwind-merge';
import MapReviewedPlacesList from './MapReviewedPlacesList';
import useSearchParam from 'src/hooks/useSearchParam';

type Props = {
  places: Place[];
  reviews: Review[];
  map: MapboxMap | null;
};

const ListMapSideContent = ({places, reviews, map}: Props) => {
  const [selectedPlaceQuery] = useSearchParam('selectedPlace');

  return (
    <div
      className={twJoin('relative h-0 max-[800px]:h-auto grow w-full', selectedPlaceQuery && 'max-[800px]:opacity-0')}
    >
      <div className="flex flex-col gap-5 max-[800px]:gap-2 h-full max-[800px]:h-auto">
        <div className="mr-6 max-[800px]:mr-4 -mb-1">
          <div className="h-px bg-(--subtle-color) w-full" />
        </div>

        <MapReviewedPlacesList places={places} reviews={reviews} map={map} />
      </div>
    </div>
  );
};

export default ListMapSideContent;
